module.exports = __webpack_public_path__ + "static/img/HugeGraph.8eac2f3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/HugeGraph.svg
// module id = A0Wq
// module chunks = 0